/**
 * Ahlam editorial parallax.
 * Slowly translates the hero media on scroll so it feels like a film pan.
 * Also drives a subtle parallax on any element marked [data-ahlam-parallax].
 * Skipped on reduced motion.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = () => {
    const heroSelectors = [
      '#shopify-section-hero_main',
      '.template-index [class*="hero"] img',
      '.template-index .hero__media-wrapper img',
      '.section-hero img',
    ];

    let heroBg = null;
    for (const sel of heroSelectors) {
      const el = document.querySelector(sel);
      if (el) {
        heroBg = el;
        break;
      }
    }

    const extraTargets = Array.from(document.querySelectorAll('[data-ahlam-parallax]'));

    const all = (heroBg ? [heroBg] : []).concat(extraTargets);
    if (!all.length) return;

    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      lastY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const y = lastY;
          // Hero background — translate the pseudo with CSS variable
          if (heroBg) {
            const offset = Math.min(y * 0.28, 360);
            heroBg.style.setProperty('--ahlam-parallax-y', `${offset}px`);
            heroBg.style.transform = `translate3d(0, ${offset * 0.4}px, 0)`;
          }
          for (const t of extraTargets) {
            const speed = parseFloat(t.dataset.ahlamParallax) || 0.25;
            const rect = t.getBoundingClientRect();
            const mid = window.innerHeight / 2;
            const delta = (rect.top + rect.height / 2 - mid) * speed;
            t.style.transform = `translate3d(0, ${-delta}px, 0)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
